export const penceToFormattedPound = (moneyInPence: number) =>
    `£${moneyInPence/100}`
;